/**
 * Query params used when the marketing site (club4x4.com.au) sends users straight to Auth0.
 * @module utils/marketingAuthEntry
 */

/** `?login=1` on `/signin` — skip gateway and open Auth0 login. */
export const MARKETING_LOGIN_QUERY = 'login'

/** `?signup=1` on `/register` — skip gateway and open Auth0 signup. */
export const MARKETING_SIGNUP_QUERY = 'signup'

/**
 * True when the URL is a marketing deep-link that should redirect to Auth0 immediately.
 */
export function isMarketingAuthEntryPath(pathname: string, search: string): boolean {
  const params = new URLSearchParams(search)
  if (pathname === '/signin' && params.get(MARKETING_LOGIN_QUERY) === '1') {
    return true
  }
  if (pathname === '/register' && params.get(MARKETING_SIGNUP_QUERY) === '1') {
    return true
  }
  return false
}

/** Gateway path when a marketing deep-link Auth0 redirect fails (no query params). */
export function marketingAuthGatewayPath(pathname: string): '/signin' | '/register' {
  return pathname === '/register' ? '/register' : '/signin'
}
